import React, { useEffect, useRef } from 'react';

import AllianceCard from 'components/AllianceCard';

import { Loyalty } from '../../services/loyaltiesService';
import {
  FragmentCardBottomToTop,
  FirstFragmentCardBottomToTop,
  FragmentAllianceCardBottomToTop,
  InnerTitleBottomToTop,
  CardsContainer,
} from './style';

interface Props {
  loyalties: Loyalty[];
  onSelect: (loyalty: Loyalty) => void;
}

const StackAllianceCards = ({ loyalties, onSelect }: Props) => {
  const numberOfLoyalties = loyalties.length;
  const lastCardRef = useRef(null);
  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    if (!ref.current) return;
    window.scrollTo(0, ref.current.offsetTop);
  };

  useEffect(() => {
    scrollToRef(lastCardRef);
  }, [lastCardRef]);

  return (
    <CardsContainer>
      {loyalties
        .sort((a, b) => (a.loyaltyName ?? '').localeCompare(b.loyaltyName ?? ''))
        .map((loyalty, index) => {
          if (numberOfLoyalties === index + 1) {
            return (
              <FragmentAllianceCardBottomToTop
                ref={lastCardRef}
                unique={loyalties.length === 1}
                onClick={() => onSelect(loyalty)}
                key={loyalty.id}
              >
                <AllianceCard
                  allianceName={loyalty.loyaltyName}
                  type={loyalty.type}
                  logo={loyalty.logo}
                  initialColor={loyalty.color.split(';')[0]}
                  finalColor={loyalty.color.split(';')[1]}
                />
              </FragmentAllianceCardBottomToTop>
            );
          }
          if (index === 0) {
            return (
              <FirstFragmentCardBottomToTop
                key={loyalty.id}
                initialColor={loyalty.color.split(';')[0]}
                finalColor={loyalty.color.split(';')[1]}
              >
                <InnerTitleBottomToTop onClick={() => onSelect(loyalty)}>{loyalty.loyaltyName}</InnerTitleBottomToTop>
              </FirstFragmentCardBottomToTop>
            );
          }
          return (
            <FragmentCardBottomToTop
              key={loyalty.id}
              initialColor={loyalty.color.split(';')[0]}
              finalColor={loyalty.color.split(';')[1]}
            >
              <InnerTitleBottomToTop onClick={() => onSelect(loyalty)}>{loyalty.loyaltyName}</InnerTitleBottomToTop>
            </FragmentCardBottomToTop>
          );
        })}
    </CardsContainer>
  );
};

export default StackAllianceCards;
